<template>
  <div class="container">
    <div class="titulo text-center">
      <h2><strong>REGISTRO DE RESERVACIONES</strong></h2>
    </div>
    <div class="row mb-3">
      <div class="col-md-4">
        <label for="fechaInicio" class="form-label">Fecha Inicio</label>
        <input
          v-model="filtro.fechaInicio"
          type="date"
          id="fechaInicio"
          class="form-control"
        />
      </div>
      <div class="col-md-4">
        <label for="fechaFin" class="form-label">Fecha Fin</label>
        <input v-model="filtro.fechaFin" type="date" id="fechaFin" class="form-control" />
      </div>
      <div class="col-md-4 d-flex align-items-end">
        <button class="btn btn-primary w-100" @click="filtrarReservaciones">
          <i class="bi bi-search"></i> Buscar
        </button>
        <button class="btn btn-secondary w-100 ms-2" @click="mostrarTodas">
          <i class="bi bi-arrow-clockwise"></i> Mostrar Todas
        </button>
      </div>
    </div>

    <input
      v-model="searchQuery"
      type="text"
      class="form-control w-25"
      placeholder="Buscar..."
    />
    <p></p>

    <table class="table table-striped table-hover table-bordered">
      <thead>
        <tr>
          <th>Id</th>
          <th>Cliente</th>
          <th>Origen</th>
          <th>Destino</th>
          <th>Fecha Reservación</th>
          <th>Hora Reservación</th>
          <th>Total Pasajeros</th>
          <th>Adultos</th>
          <th>Niños</th>
          <th>Pago Total</th>
          <th>Auto</th>
          <th>Conductor</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="reservacion in paginatedReservaciones" :key="reservacion.IdRegistro">
          <td>{{ reservacion.IdRegistro }}</td>
          <td>{{ reservacion.Cliente }}</td>
          <td>{{ reservacion.Origen }}</td>
          <td>{{ reservacion.Destino }}</td>
          <td>{{ reservacion.FechaReservacion }}</td>
          <td>{{ reservacion.HoraReservacion }}</td>
          <td>{{ reservacion.TotalPasajeros }}</td>
          <td>{{ reservacion.Adultos }}</td>
          <td>{{ reservacion.Ninos }}</td>
          <td>{{ reservacion.MontoPago }}</td>
          <td>{{ reservacion.ModeloAuto }}</td>
          <td>{{ reservacion.NombreConductor }}</td>
        </tr>
      </tbody>
    </table>

    <!-- Paginación -->
    <nav aria-label="Page navigation">
      <ul class="pagination justify-content-center">
        <li class="page-item" :class="{ disabled: currentPage === 1 }">
          <button class="page-link" @click="changePage(currentPage - 1)">Anterior</button>
        </li>
        <li
          v-for="page in totalPages"
          :key="page"
          class="page-item"
          :class="{ active: page === currentPage }"
        >
          <button class="page-link" @click="changePage(page)">{{ page }}</button>
        </li>
        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
          <button class="page-link" @click="changePage(currentPage + 1)">
            Siguiente
          </button>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      reservaciones: [],
      reservacionesFiltradas: [],
      filtro: {
        fechaInicio: "",
        fechaFin: "",
      },
      searchQuery: "",
      currentPage: 1,
      itemsPerPage: 4,
    };
  },
  computed: {
    filteredReservaciones() {
      return this.reservacionesFiltradas.filter((reservacion) => {
        return Object.values(reservacion)
          .join(" ")
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase());
      });
    },
    paginatedReservaciones() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredReservaciones.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredReservaciones.length / this.itemsPerPage);
    },
  },
  methods: {
    fetchReservaciones() {
      axios
        .get(
          this.$backendUrl+ "/index.php/reservaciones/lista_completa"
        )
        .then((response) => {
          this.reservaciones = response.data;
          this.reservacionesFiltradas = response.data; // Mostrar todas por defecto
        })
        .catch((error) => {
          console.error("Error al cargar las reservaciones:", error);
          alert("Hubo un problema al cargar las reservaciones.");
        });
    },
    filtrarReservaciones() {
      if (!this.filtro.fechaInicio || !this.filtro.fechaFin) {
        alert("Por favor selecciona ambas fechas para filtrar");
        return;
      }

      const params = {
        fechaInicio: this.filtro.fechaInicio,
        fechaFin: this.filtro.fechaFin,
      };

      axios
        .get(
          this.$backendUrl+ "/index.php/reservaciones/buscar_por_fechas",
          { params }
        )
        .then((response) => {
          if (response.data.length > 0) {
            this.reservacionesFiltradas = response.data;
          } else {
            alert(
              "No se encontraron reservaciones para el rango de fechas seleccionado."
            );
            this.reservacionesFiltradas = [];
          }
        })
        .catch((error) => {
          console.error("Error al filtrar las reservaciones:", error);
          alert("Hubo un problema al filtrar las reservaciones.");
        });
    },
    mostrarTodas() {
      this.reservacionesFiltradas = this.reservaciones;
      this.filtro.fechaInicio = "";
      this.filtro.fechaFin = "";
    },
    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
  },
  mounted() {
    this.fetchReservaciones();
  },
};
</script>

<style scoped>
.table-container {
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
}

.pagination .page-link {
  cursor: pointer;
}

.btn {
  margin-right: 5px;
}

.pagination .page-item.active .page-link {
  background-color: #007bff;
  color: white;
}

.pagination .page-item .page-link {
  color: #007bff;
}
.titulo {
  background-color: #f52349; /* Fondo rosa */
  color: white;
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
  font-size: 15px;
  padding: 15px 10px;
  margin: 5px 0 10px 0; /* Espacio superior e inferior */
}

.btn-link {
  color: #2fc1f6; /* Color de enlace */
  background-color: transparent;
  font-size: 150%;
  border: none;
  padding-right: 10px;
  align-content: center;
}

.btn-link:hover {
  color: #ce13a2; /* Color al pasar el mouse */
}

.btn-link1 {
  color: red; /* Color de enlace */
  background-color: transparent;
  font-size: 150%;
  border: none;
  padding-left: 10px;
}
</style>
